module.exports = __webpack_public_path__ + "static/media/shape_S.e24c3134.glb";